export const checkUrl = (str: string): string => {
  if (str === '' || str === undefined || str == null) return ''; // 未入力の場合にはエラー判定しない

  const result = str.toString().match(/^(https|http):\/\/.+/)
  return result ? '' : 'http://またはhttps://から始める必要があります。'
}
